<div class="property-border">
    <div class="array-label twc-p-2">{{label | translate}}</div>
    <div *ngFor="let point of property.value; let index = index" (click)="selectVertex(index)"
        [ngClass]="{ 'selectedElement': property.selected === index }" class="point-row">
        <div class="array-index twc-p-2 twc-pt-2 twc-small">{{index}}</div>
        <input twcInput *ngFor="let coord of getVisiblePointValues(point); let coordIndex = index"
            [type]="property.editable() ? 'number' : 'text'" step="any" [ngModel]="getPointCoord(point, coordIndex)"
            (ngModelChange)="changeField(coordIndex, index, $event)" [readonly]="!property.editable()"
            class="twc-small">
    </div>
</div>